import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

export interface IHeaderSectionProps {
  border?: boolean
}

const BORDER_STYLES = 'border-b border-solid border-contentareaborder'
const NO_BORDER_STYLES = 'border-b-0'
const HEADER_SECTION_STYLES =
  'uppercase text-primary font-heading text-base pb-2 font-bold tracking-wide'

export const HeaderSection: React.FC<PropsWithChildren<
  IHeaderSectionProps
>> = ({ border = false, children }) => (
  <div
    className={concatStyles([
      HEADER_SECTION_STYLES,
      border ? BORDER_STYLES : NO_BORDER_STYLES,
    ])}
  >
    {children}
  </div>
)

HeaderSection.displayName = 'Content.HeaderSection'
